
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ContraDetailGrid extends Serenity.EntityGrid<ContraDetailRow, any> {
        protected getColumnsKey() { return 'Finance.ContraDetail'; }
        protected getDialogType() { return ContraDetailDialog; }
        protected getIdProperty() { return ContraDetailRow.idProperty; }
        protected getInsertPermission() { return ContraDetailRow.insertPermission; }
        protected getLocalTextPrefix() { return ContraDetailRow.localTextPrefix; }
        protected getService() { return ContraDetailService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}